import { useLanguage } from "@/contexts/LanguageContext";

export const OrganizersSection2026 = () => {
  const { t } = useLanguage();
  
  // Row 1: "Organiser par" - 4 logos (exact order from image)
  const organizerLogos = [
    {
      src: "/lovable-uploads/4b903c46-9279-4388-8f39-f25d0f581a6e.png",
      alt: "ASFO - African Sustainable Finance Observatory",
      width: 140
    },
    {
      src: "/lovable-uploads/Epitome_Advisory.png",
      alt: "Epitome Advisory",
      width: 140
    },
    {
      src: "/lovable-uploads/iscae_nouakchott.jpg",
      alt: "ISCAE Nouakchott",
      width: 90
    },
    {
      src: "/lovable-uploads/55d7b386-c0a5-4d8d-9244-35f3e4a515d8.png",
      alt: "AFN - African Finance Network",
      width: 140
    }
  ];

  // Row 2: "Avec l'aimable soutien de" - 7 logos
  const supporterLogos = [
    {
      src: "/lovable-uploads/recherche.jpg",
      alt: "Unité de Recherche Macroéconomie, Croissance et Développement",
      width: 70
    },
    {
      src: "/lovable-uploads/ISCAE_Logo.png",
      alt: "Groupe ISCAE Casablanca",
      width: 70
    },
    {
      src: "/lovable-uploads/un.jpg",
      alt: "Université de Nouakchott",
      width: 70
    },
    {
      src: "/lovable-uploads/anrsi.jpg",
      alt: "ANRSI",
      width: 90
    },
    {
      src: "/lovable-uploads/ubm.png",
      alt: "UBM",
      width: 70
    },
    {
      src: "/lovable-uploads/FSEG_Sfax.png",
      alt: "FSEG Sfax",
      width: 70
    },
    {
      src: "/lovable-uploads/mes.png",
      alt: "Ministère de l'Enseignement Supérieur",
      width: 70
    },
    {
      src: "/lovable-uploads/ihe.png",
      alt: "IHE Business School",
      width: 70
    },
    {
      src: "/lovable-uploads/AMEF.png",
      alt: "AMEF",
      width: 70
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        {/* Organiser par */}
        <h2 className="text-xl md:text-2xl font-bold text-center text-gray-700 mb-10">
          {t('organizers.title_1')}
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-14 mb-14">
          {organizerLogos.map((logo, index) => (
            <div key={index} className="flex items-center justify-center">
              <img
                src={logo.src}
                alt={logo.alt}
                style={{ width: logo.width }}
                className="h-auto object-contain"
              />
            </div>
          ))}
        </div>

        {/* Avec l'aimable soutien de */}
        <h2 className="text-xl md:text-2xl font-bold text-center text-gray-700 mb-10">
          {t('organizers.title_2')}
        </h2>
        
        <div className="flex flex-wrap md:flex-nowrap justify-center items-center gap-4 md:gap-6overflow-x-auto md:overflow-visible">
          {supporterLogos.map((logo, index) => (
            <div key={index} className="flex items-center justify-center">
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-auto w-[64px] md:w-[72px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
